// Per-route SEO metadata. Applied client-side by <Seo /> on navigation so each
// route gets a unique title/description/canonical (Google renders JS and reads
// these). The brand-entity JSON-LD lives statically in index.html.

export const SITE_URL = 'https://candlefish.ai'
export const SITE_NAME = 'Candlefish'

export interface RouteMeta {
  title: string
  description: string
}

export const DEFAULT_META: RouteMeta = {
  title: 'Candlefish',
  description: 'Candlefish focuses on results based optimization through transformative technologies.',
}

// Keyed by exact pathname. Keep in sync with scripts/prerender.mjs and the sitemap.
export const ROUTE_META: Record<string, RouteMeta> = {
  '/': DEFAULT_META,
  '/privacy': {
    title: 'Privacy Policy - Candlefish',
    description: 'How Candlefish collects, uses, and protects your information.',
  },
  '/terms': {
    title: 'Terms of Service - Candlefish',
    description: 'The terms governing use of the Candlefish website.',
  },
}

export const NOT_FOUND_META: RouteMeta = {
  title: 'Page Not Found - Candlefish',
  description: 'The page you are looking for does not exist or has moved.',
}

/** True when a pathname maps to a real route. */
export function isKnownRoute(pathname: string): boolean {
  return Boolean(ROUTE_META[pathname])
}

/** Resolve metadata for a pathname; unknown paths get the 404 metadata. */
export function getRouteMeta(pathname: string): RouteMeta {
  return ROUTE_META[pathname] ?? NOT_FOUND_META
}

/** Build the canonical URL for a pathname (root has a trailing slash). */
export function canonicalFor(pathname: string): string {
  if (pathname === '/') return `${SITE_URL}/`
  return `${SITE_URL}${pathname.replace(/\/$/, '')}`
}
